import { X } from 'lucide-react';

interface Props {
  onOpenPromo: () => void;
  onDismiss: () => void;
}

export function GooglePlayIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 512 512"
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0 }}
      aria-hidden="true"
    >
      <path
        fill="#4285F4"
        d="M48.7 15.3c-7.3 7.8-11.7 19.3-11.7 33.3v414.8c0 14 4.4 25.5 11.7 33.3l1.8 1.7 232.4-232.5v-5.6L50.5 13.6l-1.8 1.7z"
      />
      <path
        fill="#FBBC04"
        d="M360.5 324.7l-77.6-77.7v-5.6l77.7-77.7 1.8 1 92 52.3c26.2 14.9 26.2 39.3 0 54.2l-92 52.3-1.9 1.2z"
      />
      <path
        fill="#EA4335"
        d="M282.9 247L48.7 481.2c8.6 9.1 22.8 10.3 38.6 1.3l273.2-157.8-77.6-77.7z"
      />
      <path
        fill="#34A853"
        d="M282.9 265L360.5 187.3 87.3 32.2C71.5 23.2 57.3 24.4 48.7 33.5L282.9 265z"
      />
    </svg>
  );
}

export function PlayStoreTopBanner({ onOpenPromo, onDismiss }: Props) {
  return (
    <aside className="app-promo-top-banner" aria-label="Official Android App Announcement">
      <div className="app-promo-top-banner__glow" />
      <div className="app-promo-top-banner__main">
        <div className="app-promo-top-banner__icon-wrapper">
          <GooglePlayIcon size={20} />
        </div>
        <div className="app-promo-top-banner__copy">
          <div className="app-promo-top-banner__tagline">
            <span className="app-promo-top-banner__live-pill">
              <span className="app-promo-top-banner__pulse-dot" />
              <span className="app-promo-top-banner__live-text">Now Live</span>
            </span>
            <strong className="app-promo-top-banner__title">
              <span className="app-promo-top-banner__title-full">MHC Court Pulse is on Google Play</span>
              <span className="app-promo-top-banner__title-mobile">MHC Court Pulse</span>
            </strong>
          </div>
          <span className="app-promo-top-banner__desc">
            Track daily cause lists & get real-time case call notifications on Android.
          </span>
        </div>
      </div>

      <div className="app-promo-top-banner__actions">
        <button
          type="button"
          className="app-promo-top-banner__btn"
          onClick={onOpenPromo}
        >
          <GooglePlayIcon size={14} />
          <span className="app-promo-top-banner__btn-full">Get App / Scan QR</span>
          <span className="app-promo-top-banner__btn-mobile">Get App</span>
        </button>
        <button
          type="button"
          className="app-promo-top-banner__close"
          onClick={onDismiss}
          aria-label="Dismiss mobile app banner"
        >
          <X size={15} />
        </button>
      </div>
    </aside>
  );
}
